<template>
  <el-drawer
    v-loading="loading"
    title="核销"
    :visible.sync="drawer"
    direction="btt"
    size="95%"
    :before-close="handleClose"
  >
    <div class="view">
      <div class="water">
        <!-- <div class="title">充值水单</div> -->
        <el-tabs v-model="activeName" @change="waterSelectionRow = {}">
          <el-tab-pane label="上传水单" name="0">
            <el-form ref="form" :model="form" :rules="rules" class="formmain">
              <div class="bank">
                <label class="label"><span class="red">*</span> 收款账号</label>
                <div class="bank-select" @click="dialogVisible2 = true">
                  <template v-if="!supplyItem.id">
                    <svg-icon className="icon1" iconClass="add" />
                    <span class="add">选择账号</span>
                  </template>
                  <template v-if="supplyItem.id">
                    <div class="panle">
                      <div class="left">
                        <svg-icon
                          className="icon"
                          :iconClass="supplyItem.iconClass"
                        />
                        <div class="content">
                          <p class="bank-name">
                            {{ supplyItem.bankName }}
                            <span :class="supplyItem.currency.toUpperCase()">{{
                              supplyItem.currency.toUpperCase()
                            }}</span>
                          </p>
                          <p class="bank-name">
                            {{ supplyItem.bankBranchName }}
                          </p>
                          <p class="bank-number">
                            {{ supplyItem.accountNumber }}
                          </p>
                          <p class="address">{{ supplyItem.accountName }}</p>
                        </div>
                      </div>
                      <div class="right">
                        <span
                          class="change-account"
                          @click="dialogVisible2 = true"
                        >更换账号</span
                        >
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div>
                <el-form-item label="付款账户名" prop="paymentAccountName">
                  <el-input
                    v-model="form.paymentAccountName"
                    style="width: 320px"
                    placeholder="请输入付款账户名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="金额" prop="sourceAmount">
                  <el-input-number
                    v-model="form.sourceAmount"
                    style="width: 100%"
                    controls-position="right"
                    :min="0.01"
                    :precision="2"
                    @change="sourceAmountChange"
                  ></el-input-number>
                </el-form-item>
              </div>
              <el-form-item label="币制" prop="sourceCurrency">
                <el-select
                  v-model="form.sourceCurrency"
                  style="width: 320px"
                  placeholder="请选择计算方式"
                  disabled
                  @change="currencyChange"
                >
                  <el-option
                    v-for="item in currencyOption"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="汇率" prop="exchangeRate">
                <el-input
                  v-model="form.exchangeRate"
                  disabled
                  style="width: 320px"
                ></el-input>
              </el-form-item>
              <el-form-item label="结算币制" prop="realCurrency">
                <el-input
                  v-model="form.realCurrency"
                  style="width: 320px"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="到账金额" prop="realAmount">
                <el-input
                  v-model="form.realAmount"
                  style="width: 320px"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item label="到账日期" prop="receiptOn">
                <!-- <el-input
              v-model="form.description"
              style="width: 320px"
              placeholder="请填写备注"
            ></el-input> -->
                <el-date-picker
                  v-model="form.receiptOn"
                  type="date"
                  placeholder="选择日期"
                  style="width: 320px"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="备注" prop="description">
                <el-input
                  v-model="form.description"
                  style="width: 320px"
                  placeholder="请填写备注"
                ></el-input>
              </el-form-item>
              <el-form-item label="附件" prop="systemFileId">
                <div class="view-upload">
                  <el-upload
                    class="upload-demo"
                    drag
                    :action="`/api/SystemFile/uploadFile?source=2`"
                    :headers="headers"
                    :multiple="false"
                    :file-list="fileList"
                    :show-file-list="false"
                    :data="{ source: 2 }"
                    :on-success="handlesuccess"
                    :on-error="onError"
                    :on-progress="handlePreview"
                    :on-remove="handleRemove"
                    :on-exceed="handleExceed"
                    :limit="1"
                    :before-upload="beforeUpload"
                  >
                    <svg-icon iconClass="upload" className="icon" />
                    <div class="btn">选择文件</div>
                    <p class="el-upload__text">只支持图片格式上传</p>
                  </el-upload>
                  <div class="file-list">
                    <div
                      v-for="(item, $index) in fileList"
                      :key="$index"
                      class="panle"
                    >
                      <div class="left">
                        <img
                          src="@/assets/images/const/constwiimg.png"
                          width="32"
                          height="32"
                        />
                        <div class="file">
                          <p class="file-name">{{ item.name }}</p>
                          <p class="file-size">
                            {{ item.size | formatterSize }} MB
                            <el-progress
                              style="width: 260px; margin-left: 20px"
                              :width="220"
                              :percentage="percentage"
                            ></el-progress>
                          </p>
                        </div>
                      </div>
                      <div class="right">
                        <i class="el-icon-delete gou" @click="removeFiles" />
                      </div>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="选择水单" name="1">
            <BaseTable
              v-if="drawer"
              :height="500"
              :tableData="{
                ...tableDataByWaterBill,
                fileds
              }"
              :loading="loading"
              :isPager="false"
              :isEmptyBorder="true"
              @handlerRadio="handlerRadio"
            >
              <template slot="companyId" slot-scope="row">
                <p>{{ formatterCompany(row.scope.companyId) }}</p>
              </template>
              <template slot="companyId" slot-scope="row">
                <p>{{ formatterCompany(row.scope.companyId) }}</p>
              </template>
              <template slot="remainingVerifyAmount" slot-scope="row">
                <p style="color: #304156; font-weight: bold">
                  {{ row.scope.remainingVerifyAmount || 0 }}
                </p>
              </template>
            </BaseTable>
          </el-tab-pane>
        </el-tabs>
        <!-- <div class="footer">
          <div class="ok flex_c_c" @click="submitBill('form')">确定上传</div>
        </div> -->
      </div>
      <div class="check">
        <!-- <div class="title">核销</div> -->
        <div class="header">
          <el-row>
            <el-col :span="6">
              <label class="label">{{ !active ? '客户' : '代理' }}</label>
              <span class="value">
                {{ rowData.companyName || rowData.supplierName }}
              </span>
            </el-col>
            <el-col v-if="!active" :span="6">
              <label class="label">业务员</label>
              <span class="value"> {{ rowData.saleName }}</span>
            </el-col>
            <el-col :span="6">
              <label class="label">账单总金额</label>
              <span class="value"> {{ rowData.invoiceAmount }}</span>
            </el-col>
            <el-col :span="6">
              <label class="label">已确认金额</label>
              <span class="value"> {{ rowData.unverifyConfirmAmount }}</span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 12px">
            <el-col :span="6">
              <label class="label">未确认金额</label>
              <span class="value"> {{ rowData.unverifyUnConfirmAmount }}</span>
            </el-col>
            <el-col :span="6">
              <label class="label">已核销金额</label>
              <span class="value"> {{ rowData.verifedAmount }}</span>
            </el-col>
            <el-col :span="6">
              <label class="label">账单未核销金额</label>
              <span class="value"> {{ rowData.unverifyInoviceAmountUnCk }}</span>
            </el-col>
            <el-col :span="6">
              <label class="label">剩余可核销金额</label>
              <span class="value">
                {{ rowData.remainingVerifiableAmount }}</span
              >
            </el-col>
          </el-row>
          <el-row style="margin-top: 12px">
            <el-col :span="6">
              <label class="label">最后核销日期</label>
              <span class="value">
                {{ rowData.lastVerifyDate }}
              </span>
            </el-col>
            <el-col :span="12" style="display: flex">
              <label
                class="label"
                style="margin-top: 5px"
              >本次核销总金额</label
              >
              <span class="value" style="display: flex">
                <div>
                  <el-input-number
                    v-model="verifyAmount"
                    size="mini"
                    :min="0"
                    :max="verifyAmountMax"
                    placeholder="请输入核销金额"
                    style="width: 100%"
                    controls-position="right"
                    @change="handleChange"
                  ></el-input-number>
                </div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="核销总金额默认=到账金额，核销总金额可以手动调整为不等于到账金额，差额部分为手续费退还到客户当前余额，即:手续费=到账金额-核销总金额"
                  placement="bottom"
                >
                  <i
                    style="
                      color: #f56c6c;
                      color: rgb(245, 108, 108);
                      margin-top: 5px;
                      font-size: 20px;
                      margin-left: 8px;
                      cursor: pointer;
                    "
                    class="el-icon-warning-outline"
                  />
                </el-tooltip>
              </span>
            </el-col>
          </el-row>
        </div>
        <div class="data">
          <BaseTable
            ref="baseTable"
            :height="320"
            :tableData="tableData"
            :loading="false"
            :isPager="false"
            :border="true"
            @handleSelectionChange="handleSelectionChange"
          >
            <template slot="unVerifedAmount" slot-scope="row">
              {{ fomatterUnVerifedAmount(row.scope) }}
              <!-- {{ (row.scope.amount - (row.scope.verifedAmountByNow || 0)).toFixed(2) }} -->
            </template>
            <template slot="verifedAmountByNow" slot-scope="row">
              <el-input-number
                v-model="row.scope.verifedAmountByNow"
                :disabled="row.scope.unVerifedAmount < 0"
                size="mini"
                :min="
                  row.scope.unVerifedAmount > 0 ? 0 : row.scope.unVerifedAmount
                "
                :max="
                  row.scope.unVerifedAmount > 0
                    ? (verifyAmountMax > row.scope.unVerifedAmount ? row.scope.unVerifedAmount : verifyAmountMax)
                    : 9999999
                "
                placeholder="请输入核销金额"
                style="width: 100%"
                controls-position="right"
              ></el-input-number>
            </template>
          </BaseTable>
          <div class="select">
            <p>
              总金额
              <span class="money" style="margin-right: 10px">{{
                sumAmount
              }}</span>
              未核销金额
              <span class="money">{{ sumUnVerifedAmount }}</span>
              本次核销金额
              <span class="money">
                {{ sunVerifedAmount }}
                <span class="money" style="margin-left: 12px;"><i class="el-icon-warning-outline" />本次总核销金额必须大于0</span>
              </span>
            </p>
            <p>
              总未核销金额 <span class="money">
                {{ totalUnVerifedAmount }}
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="cancel flex_c_c" @click="handleClose">取 消</div>
      <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </div>
    <select-company-bank-dialog
      :dialogVisible="dialogVisible2"
      :companyId="rowData?.companyId"
      :supplierId="rowData?.supplierId"
      :typeActive="active"
      @ok="ok2"
      @cancel="cancel2"
    ></select-company-bank-dialog>
  </el-drawer>
</template>
<script>
import SelectCompanyBankDialog from './SelectCompanyBankDialog.vue'
import { getCurrency, getExchangeRate } from '@/api/fee'
// import { addPayment } from '@/api/client'
import { getPaymentPagesList } from '@/api/client'
import { getPaymentPagesListBySupplier } from '@/api/supplierPayment'

import config from '@/utils/config'
import { mapGetters } from 'vuex'
const BaseTable = () => import('@/components/table/BaseTable')
import Decimal from 'decimal.js'
import {
  verify,
  usageVerifyDetail,
  verifyBySupplier,
  usageVerifyDetailBySupplier
} from '@/api/fee'
import dayjs from 'dayjs'
export default {
  components: { SelectCompanyBankDialog, BaseTable },
  filters: {
    formatterSize(size) {
      return (size / 1024 / 1024).toFixed(2)
    }
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      config,
      headers: { 'ESCLEARANCE': btoa(`BC5BC301345F4D57CC1A8EF1F74579A7&${Date.now()}`) },
      activeName: '0',
      fileList: [],
      supplyItem: {},
      form: {
        paymentAccountName: '',
        realCurrency: '',
        sourceCurrency: '',
        sourceAmount: '',
        exchangeRate: '',
        realAmount: '',
        description: '',
        receiptOn: '',
        systemFileId: ''
      },
      rules: {
        sourceCurrency: [
          {
            required: true,
            message: '请选择币制',
            trigger: 'change'
          }
        ],
        realCurrency: [
          {
            required: true,
            message: '请选择币制',
            trigger: 'change'
          }
        ],
        receiptOn: [
          {
            required: true,
            message: '请选择币制',
            trigger: 'change'
          }
        ],
        realAmount: [
          {
            required: true,
            message: '请输入金额',
            trigger: 'blur'
          }
        ],
        sourceAmount: [
          {
            required: true,
            message: '请输入金额',
            trigger: 'blur'
          }
        ],
        exchangeRate: [
          {
            required: true,
            message: '请输入汇率',
            trigger: 'blur'
          }
        ],
        paymentAccountName: [
          {
            required: true,
            message: '请输入付款账户名',
            trigger: 'blur'
          }
        ],
        systemFileId: [
          {
            required: true,
            message: '请上传文件',
            trigger: 'change'
          }
        ]
      },
      currencyOption: [],
      uploadData: {},
      dialogVisible2: false,
      supplySelect: 0,
      percentage: 0,
      tableData: {
        fileds: [
          {
            filed: 'containerNo',
            label: '柜号',
            width: '',
            resizable: true
          },
          {
            filed: 'invoiceNumber',
            label: '账单号码',
            width: '',
            resizable: true
          },
          {
            filed: 'invoiceDateStr',
            label: '账单日期',
            width: '',
            resizable: true
          },
          {
            filed: 'amount',
            label: '总金额',
            width: '',
            resizable: true
          },
          {
            filed: 'verifedAmount',
            label: '已核销金额',
            width: '',
            resizable: true
          },
          {
            filed: 'unVerifedAmount',
            label: '未核销金额',
            width: '',
            isCustom: true,
            resizable: true
          },
          {
            filed: 'verifedAmountByNow',
            label: '本次核销金额',
            width: '',
            isCustom: true,
            resizable: true
          }
        ],
        columns: [],
        mutiCheck: true,
        mutiFixed: 'left'
      },
      tableDataByWaterBill: {
        fileds: [
          {
            filed: 'createdOn',
            label: '上传日期',
            width: '',
            formatter: (row) => {
              return row.createdOn
                ? dayjs(row.createdOn).format('YYYY-MM-DD')
                : ''
            }
          },
          {
            filed: 'uploadType',
            label: '类型',
            width: '',
            resizable: true,
            formatter: row => row.uploadType ? '预充值' : '在线充值'
          },
          {
            filed: 'companyId',
            label: '付款人',
            width: '',
            isCustom: true
          },
          {
            filed: 'bankAccountNumber',
            label: '收款账号',
            width: ''
          },
          {
            filed: 'bankName',
            label: '收款银行',
            width: ''
          },
          {
            filed: 'receiptOn',
            label: '到账日期',
            width: '',
            formatter: (row) => {
              return row.receiptOn
                ? dayjs(row.receiptOn).format('YYYY-MM-DD')
                : ''
            }
          },
          {
            filed: 'receivedAmount',
            label: '到账金额',
            width: ''
          },
          {
            filed: 'verifedAmount',
            label: '核销金额',
            width: '',
            formatter: (row) => {
              return row.verifedAmount || 0
            }
          },
          {
            filed: 'remainingVerifyAmount',
            label: '剩余核销金额',
            width: '',
            isCustom: true
          }
        ],
        columns: [],
        total: 0,
        showRadio: true
      },
      loading: false,
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      selectArr: [],
      selecItems: [],
      // companyId: '',
      listStatus: true,
      orderObj: {},
      verifyAmount: 0,
      waterSelectionRow: {},
      verifyAmountMax: 0 // 充值金额
    }
  },
  computed: {
    ...mapGetters(['selectSupply', 'companyDrapdown']),
    totalUnVerifedAmount() {
      let num = 0
      this.tableData.columns.forEach((item) => {
        num += +item.unVerifedAmount
      })
      return num.toFixed(2)
    },
    sumAmount() {
      return this.selecItems.reduce((a, b) => {
        return new Decimal(a).add(new Decimal(b.amount)).toNumber()
      }, 0)
    },
    sumUnVerifedAmount() {
      return this.selecItems
        .reduce((a, b) => {
          return new Decimal(a)
            .add(
              new Decimal(b.amount)
                .sub(new Decimal(b.verifedAmount || 0))
                .sub(new Decimal(b.verifedAmountByNow || 0)),
            )
            .toNumber()
        }, 0)
        .toFixed(2)
    },
    sunVerifedAmount() {
      return this.selecItems
        .reduce((a, b) => {
          return new Decimal(a)
            .add(new Decimal(b.verifedAmountByNow))
            .toNumber()
        }, 0)
        .toFixed(2)
    },
    fileds() {
      const arr = [...this.tableDataByWaterBill.fileds]
      if (this.active) {
        arr.splice(1, 1)
      }
      return arr
    }
  },
  watch: {
    drawer(val) {
      if (val) {
        this.verifyAmount = 0
        this.activeName = '0'
        this.listStatus = true
        this.fileList = []
        this.supplyItem = {}
        this.selecItems = []
        this.getLists({ companyId: this.rowData.companyId, supplierId: this.rowData.supplierId })
        this.getWaterBillList()
        this.getCurrencyList()
        this.$refs['form']?.resetFields()
      }
    }
  },
  methods: {
    handleSelectionChange(item) {
      this.selecItems = item
    },
    formatterCompany(companyId) {
      const item = this.companyDrapdown.find((a) => a.value === companyId)
      return item ? item.label : ''
    },
    async getWaterBillList() {
      try {
        let res
        if (!this.active) {
          res = await getPaymentPagesList({
            pageIndex: 1,
            pageSize: 500,
            queryParam: {
              paymentStatus: [2],
              canVerify: true,
              companyId: this.rowData.companyId
            }
          })
        } else {
          res = await getPaymentPagesListBySupplier({
            pageIndex: 1,
            pageSize: 500,
            queryParam: {
              paymentStatus: [2],
              canVerify: true,
              supplierId: this.rowData.supplierId
            }
          })
        }

        if (res.success) {
          this.tableDataByWaterBill.columns = res.data.list
          this.tableDataByWaterBill.total = res.data.totalCount
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    handlerRadio(item) {
      this.verifyAmount = item.remainingVerifyAmount
      this.verifyAmountMax = item.remainingVerifyAmount
      this.waterSelectionRow = item
      this.$nextTick(() => {
        this.handleChange()
      })
      // this.verifyAmount = item.reduce((a, b) => {
      //   return new Decimal(a).add(new Decimal(b.remainingVerifyAmount))
      // }, 0)
    },
    async getCurrencyList() {
      const res = await getCurrency({
        identityCode: this.identityCode
      })
      if (res.success) {
        this.currencyOption = res.data
      } else {
        this.$message.error(res.errorMessage)
      }
    },
    handleClose() {
      // this.$confirm('确认关闭？')
      //   .then(() => {
      this.$emit('close')
      // })
      // .catch(() => {})
    },
    ok2(item) {
      let currency
      if (!this.active) {
        currency = this.companyDrapdown.find(
          (a) => a.id === this.rowData.companyId,
        ).currency
      } else {
        currency = item.currency
      }
      this.supplyItem = item
      this.form.sourceCurrency = item.currency
      this.form.realCurrency = currency
      if (item.currency !== this.form.realCurrency && this.form.realCurrency) {
        const params = {
          sourceCurrency: item.currency,
          destinationCurrency:
            this.form.realCurrency.toUpperCase() === 'RMB'
              ? item.currency
              : this.form.realCurrency
        }
        this.getCurrencyExchangeRate(params)
      } else {
        this.form.exchangeRate = 1
        this.getRealAmount()
      }
      this.cancel2()
    },
    cancel2() {
      this.dialogVisible2 = false
    },
    getCurrencyExchangeRate(params) {
      getExchangeRate({
        type: 0,
        ...params
      }).then((res) => {
        console.log(res)
        if (res.success) {
          this.form.exchangeRate = res.data.rateValue
          if (this.form.sourceAmount) {
            this.getRealAmount()
          }
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    sourceAmountChange() {
      if (this.form.exchangeRate) {
        this.getRealAmount()
      }
    },
    getRealAmount() {
      if (this.form.realCurrency.toUpperCase() === 'RMB') {
        this.form.realAmount = (
          this.form.sourceAmount * this.form.exchangeRate
        ).toFixed(2)
        this.verifyAmount = (
          this.form.sourceAmount * this.form.exchangeRate
        ).toFixed(2) // 本次核销总金额 默认实际到账金额
        this.verifyAmountMax = +(
          this.form.sourceAmount * this.form.exchangeRate
        ).toFixed(2)
      } else {
        this.form.realAmount = (
          this.form.sourceAmount / this.form.exchangeRate
        ).toFixed(2)
        this.verifyAmount = (
          this.form.sourceAmount / this.form.exchangeRate
        ).toFixed(2) // 本次核销总金额 默认实际到账金额
        this.verifyAmountMax = +(
          this.form.sourceAmount / this.form.exchangeRate
        ).toFixed(2)
      }
      this.$nextTick(() => {
        this.handleChange()
      })
    },
    currencyChange(val) {
      if (
        val.toUpperCase() !== this.form.realCurrency.toUpperCase() &&
        this.form.realCurrency
      ) {
        const params = {
          sourceCurrency: val,
          destinationCurrency:
            this.form.realCurrency.toUpperCase() === 'RMB'
              ? val
              : this.form.realCurrency
        }
        this.getCurrencyExchangeRate(params)
      }
    },
    handleRemove() {
      this.fileList = []
      this.form.systemFileId = ''
    },
    removeFiles() {
      this.form.systemFileId = ''
      this.fileList = []
    },
    beforeUpload(file) {
      const types = ['image/jpeg', 'image/jpg', 'image/png']
      const isImage = types.includes(file.type)
      if (!isImage) {
        this.$message.error('只能上传图片')
        return false
      }
      this.fileList.push(file)
    },
    handlePreview(event, file) {
      this.percentage = file.percentage
    },
    handlesuccess(response, file, fileList) {
      console.log(response, file, fileList)
      if (response.success) {
        this.form.systemFileId = response.data.id
        this.percentage = 100
      } else {
        this.$message.error(response.errorMessage)
        this.fileList = []
        this.form.systemFileId = ''
      }
    },
    handleExceed() {
      this.$message.warning('只允许上传一个文件，请删除后再上传')
    },
    onError(err, file, fileList) {
      console.log(err, file, fileList)
    },
    async getLists(params) {
      try {
        this.loading = true
        let res
        if (!this.active) {
          res = await usageVerifyDetail(params)
        } else {
          res = await usageVerifyDetailBySupplier(params)
        }
        this.loading = false
        if (res.success) {
          let num = 0
          this.tableData.columns = res.data.map((item) => {
            // num += +item.unVerifedAmount
            num = new Decimal(num).add(new Decimal(item.unVerifedAmount))
            return {
              ...item,
              verifedAmountByNow: item.unVerifedAmount
            }
          })
          // this.verifyAmount = num
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    handleChange() {
      if (!this.verifyAmount) return
      // const tableData = [...this.tableData.columns]
      // let num = this.verifyAmount
      // for (let i = 0; i < tableData.length; i++) {
      //   if (num >= +tableData[i].unVerifedAmount) {
      //     num -= +tableData[i].unVerifedAmount
      //     tableData[i].verifedAmountByNow = +tableData[i].unVerifedAmount
      //   } else if (num > 0) {
      //     tableData[i].verifedAmountByNow = num
      //     num -= num
      //   } else {
      //     tableData[i].verifedAmountByNow = 0
      //   }
      // }
      // this.tableData.columns = [...tableData]
      const tableData = JSON.parse(JSON.stringify(this.tableData.columns))
      let num = new Decimal(this.verifyAmount)
      for (let i = 0; i < tableData.length; i++) {
        if (num.cmp(new Decimal(tableData[i].unVerifedAmount)) >= 0) {
          num = num.sub(new Decimal(tableData[i].unVerifedAmount))
          tableData[i].verifedAmountByNow = new Decimal(
            tableData[i].unVerifedAmount,
          ).toNumber()
        } else if (num.cmp(new Decimal(0)) >= 0) {
          tableData[i].verifedAmountByNow = num.toNumber()
          num = num.sub(num)
        } else {
          tableData[i].verifedAmountByNow = 0
        }
      }
      if (num.toNumber() > 0) {
        this.verifyAmount = new Decimal(this.verifyAmount).sub(num)
      }
      console.log('num', num.toNumber())
      this.tableData.columns = [...tableData]
      // 勾选数据
      this.$nextTick(() => {
        this.tableData.columns.forEach(row => {
          if (row.verifedAmountByNow !== 0) {
            this.$refs.baseTable.toggleRowSelection(row)
          }
        })
      })
    },
    async ok(formName) {
      if (!this.selecItems.length) {
        this.$message.error('没有勾选核销数据')
        return
      }
      if (+this.sunVerifedAmount < 0) {
        this.$message.error('本次核销金额必须大于0')
        return
      }
      const verifies = this.tableData.columns
        .filter((item) => {
          return !(item.unVerifedAmount !== 0 && item.verifedAmountByNow === 0)
        })
        .map((item) => {
          return {
            invoiceId: item.invoiceId,
            containerNo: item.containerNo,
            verifedAmount: item.verifedAmountByNow
          }
        })
      const sum = this.selecItems.reduce((pre, cur) => {
        // return pre + +cur.verifedAmountByNow
        return new Decimal(pre).add(new Decimal(cur.verifedAmountByNow))
      }, 0)
      if (sum.toNumber() > +this.verifyAmount) {
        this.$message.error('本次核销金额不能大于本次核销总金额')
        return
      }
      if (this.activeName !== '0') {
        if (!this.waterSelectionRow.id) {
          this.$message.warning('请选择预充值数据')
          return
        }
        try {
          this.loading = true
          let res
          if (!this.active) {
            res = await verify({
              verifies,
              paymentId: this.waterSelectionRow.id
            })
          } else {
            res = await verifyBySupplier({
              verifies,
              paymentId: this.waterSelectionRow.id
            })
          }
          this.loading = false
          if (res.success) {
            this.$message.success('操作成功')
            this.$refs[formName]?.resetFields()
            this.supplyItem = {}
            this.fileList = []
            this.selectArr = []
            this.$emit('ok')
          } else {
            this.$message.error(res.errorMessage)
          }
        } catch (error) {
          console.log(error)
        }
      } else {
        this.$refs[formName].validate(async(valid) => {
          if (valid) {
            if (!this.supplyItem.id) {
              this.$message.warning('请选择收款账号')
              return
            }
            if (!this.form.systemFileId) {
              this.$message.warning('请上传附件')
              return
            }

            try {
              const payment = {
                suppilerCode: this.config.supplyCode,
                bankAccountNumber: this.supplyItem.accountNumber,
                systemFileId: this.form.systemFileId,
                ...this.form,
                companyId: this.rowData.companyId,
                supplierId: this.rowData.supplierId,
                realAmount: parseFloat(this.form.realAmount),
                sourceAmount: parseFloat(this.form.sourceAmount)
              }

              this.loading = true
              let res
          if (!this.active) {
               res = await verify({
                verifies,
                payment
              })
          } else {
            res = await verifyBySupplier({
              verifies,
             payment
            })
          }
              this.loading = false
              if (res.success) {
                this.$message.success('操作成功')
                this.$refs[formName]?.resetFields()
                this.supplyItem = {}
                this.fileList = []
                this.selectArr = []
                this.$emit('ok')
              } else {
                this.$message.error(res.errorMessage)
              }
            } catch (error) {
              console.log(error)
            }
          }
        })
      }
    },
    fomatterUnVerifedAmount(row) {
      // (row.scope.amount - (row.scope.verifedAmountByNow || 0)).toFixed(2)
      return new Decimal(row.amount)
        .sub(new Decimal(row.verifedAmount || 0))
        .sub(new Decimal(row.verifedAmountByNow || 0))
        .toNumber()
    }
  }
}
</script>
<style lang="less" scoped>
.view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  padding: 12px;
  box-sizing: border-box;
  background: #f5f5f5;
}
.water {
  width: calc(50% - 6px);
  height: calc(100% - 60px);
  background: #fff;
  padding: 12px;
  box-sizing: border-box;
  position: relative;

  .formmain {
    margin: 0 auto;
    width: 675px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    &:deep(.el-form-item) {
      margin-bottom: 20px;
    }
    &:deep(.el-form-item__label) {
      line-height: 30px;
    }
  }
  .bank {
    width: 320px;
    background: #fff;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
  }
  .label {
    width: 100%;
    height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #25396f;
    line-height: 40px;
  }
  .red {
    color: #ff7444;
  }
  .bank-select {
    width: 320px;
    height: 124px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid #dbe4f2;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .panle {
      width: calc(100% - 32px);
      height: 90px;
      background: #f8fbff;
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      padding: 16px;
      justify-content: space-between;
      display: flex;
      position: relative;
      & + .panle {
        margin-top: 8px;
      }
    }
    .left {
      display: flex;
    }
    .bank-name {
      height: 16px;
      font-size: 12px;
      font-weight: 400;
      color: #7c8db5;
      line-height: 16px;
      overflow: hidden;
    }
    .bank-number {
      margin-top: 8px;
      height: 26px;
      font-size: 20px;
      font-weight: 400;
      color: #25396f;
      line-height: 26px;
    }
    .address {
      height: 16px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #7c8db5;
      line-height: 16px;
      overflow: hidden;
    }
    .RMB {
      width: 27px;
      height: 16px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #fe453d;
      line-height: 16px;
      padding: 2px 4px;
      background: rgba(254, 69, 61, 0.1);
      border-radius: 4px 4px 4px 4px;
      margin-left: 10px;
    }
    .USD {
      width: 27px;
      height: 16px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #35ba83;
      line-height: 16px;
      padding: 2px 4px;
      background: rgba(53, 186, 131, 0.1);
      border-radius: 4px 4px 4px 4px;
      margin-left: 10px;
    }
    .icon {
      font-size: 32px;
      margin-right: 8px;
    }
    .change-account {
      height: 16px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      line-height: 16px;
      position: absolute;
      width: 48px;
      right: 16px;
    }
  }
  .icon1 {
    font-size: 20px;
    color: rgb(18, 88, 188);
  }
  .add {
    width: 56px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    line-height: 19px;
    margin-left: 5px;
  }
}
.check {
  width: calc(50% - 6px);
  height: calc(100% - 60px);
  background: #fff;
  padding: 12px;
  position: relative;
  box-sizing: border-box;
  .header {
    width: 100%;
    background: #fbfbfb;
    border-radius: 6px 6px 6px 6px;
    padding: 16px 32px;
    box-sizing: border-box;
    .label {
      display: inline-block;
      width: 94px;
      height: 16px;
      background: rgba(105, 89, 205, 0.1);
      border-radius: 4px 4px 4px 4px;
      text-align: center;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #6959cd;
      line-height: 16px;
    }
    .value {
      height: 16px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 16px;
      margin-left: 6px;
    }
  }
  .data {
    width: 100%;
    border-radius: 4px 4px 4px 4px;
    margin-top: 12px;
    .fTable {
      height: 320;
    }
    .select {
      margin-top: 10px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      display: flex;
      height: 32px;
      line-height: 32px;
      padding: 0 32px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      span {
        color: rgb(18, 88, 188);
      }
      .money {
        color: #ff7c4b;
        & + .money {
          margin-right: 10px;
        }
      }
    }
  }
}
.view-upload {
  width: 675px;
  margin: 0 auto;
  height: auto;
  .upload-demo {
    width: 100%;
    height: 180px;
  }
  &:deep(.el-upload) {
    width: 100%;
    height: 160px;
  }
  &:deep(.el-upload-dragger) {
    width: 100%;
    height: 160px;
  }
  &:deep(.el-upload-dragger) {
    background: #f8fbff;
    border: 0;
  }
  &:deep(.el-upload__text) {
    width: 100%;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #b8c3de;
    line-height: 24px;
    margin-top: 10px;
  }
  .btn {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    border: 1px solid rgb(18, 88, 188);
    margin: 10px auto 0;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: rgb(18, 88, 188);
    line-height: 40px;
  }
  .file-list {
    width: 100%;
    height: auto;
    margin-top: 20px;
    .left {
      display: flex;
      align-items: center;
      width: calc(100% - 16px);
    }
    .panle {
      width: calc(100% - 48px);
      height: 40px;
      padding: 12px 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.1);
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
    }
    .file {
      margin-left: 15px;
      width: 100%;
      .file-name {
        width: 100%;
        height: 19px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 19px;
      }
      .file-size {
        display: flex;
        height: 16px;
        width: 100%;
        font-size: 12px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 16px;
        margin-top: 4px;
      }
    }
    .gou {
      font-size: 24px;
      color: #b8c3de;
      cursor: pointer;
    }
  }
  .icon {
    font-size: 60px;
    color: rgb(18, 88, 188);
    margin-top: 10px;
  }
  .icon1 {
    font-size: 40px;
    color: rgb(18, 88, 188);
  }
}
.title {
  display: inline-block;
  padding: 4px 12px;
  width: auto;
  height: 30px;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  position: absolute;
  color: #1258bc;
  background: rgba(35, 149, 243, 0.1);
  top: 0;
  left: 0;
}

.footer {
  width: 100%;
  height: 60px;
  background: #ffffff;
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 0px 0px 0px 0px;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #eeeeee;
    border-radius: 4px 4px 4px 4px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #999999;
    cursor: pointer;
    text-align: center;
    line-height: 40px;
  }
  .ok {
    width: 120px;
    height: 40px;
    margin-left: 20px;
    background: #0b3571;
    border-radius: 4px 4px 4px 4px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    cursor: pointer;
    line-height: 40px;
  }
  span {
    margin-left: 20px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #148657;
  }
}
</style>
